'use client';
import { useTranslations } from 'next-intl';
import * as React from 'react';

export default function Error({ error }: { error: Error & { digest?: string }; reset: () => void }) {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.error(error);
  }, [error]);

  const t = useTranslations('error');

  return (
    <main>
      <section className="bg-white dark:bg-slate-950">
        <div className="layout flex min-h-screen flex-col items-center justify-center text-center text-black dark:text-white">
          <h1 className="mt-8 text-4xl md:text-6xl">{t('error_message')}</h1>
        </div>
      </section>
    </main>
  );
}
